import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import BOMReMatchRepository from "../../../repository/BOMReMatchRepository";
import {__remove, __set} from "../../axios_indicator";

const initialState = {
    row_selected_number: 1,
    static_columns: {},
    bomDataList: {},
    bomDataListMainCopy: {},
    columnMappingList: {},
};

export const fetch_static_columns = createAsyncThunk('bom_fetchStaticColumns', async () => {
    __set('BOM_REMATCH_API_CALL');
    return await new BOMReMatchRepository().fetchStaticColumns();
});

export const fetch_saved_columns_data_by_bom_id = createAsyncThunk('bom_fetchSavedColumnsDataByBomID', async (params) => {
    __set('BOM_REMATCH_SAVED_API_CALL');
    return await new BOMReMatchRepository().fetchSavedColumnsDataByBomID(params);
});

export const fetch_saved_preference_by_bom_id = createAsyncThunk('bom_fetchSavedPreferenceByBomID', async (params) => {
    __set('BOM_REMATCH_SAVED_PREFERENCE_API_CALL');
    return await new BOMReMatchRepository().fetchSavedColumnsPreferenceByBomID(params);
});

export const set_saved_columns_preference_by_bom_id = createAsyncThunk('bom_savedColumnsPreferenceByBomID', async (params) => {
    __set('BOM_REMATCH_OPERATION_API_CALL');
    return await new BOMReMatchRepository().saveColumnsPreferenceByBomID(params.bomId, params.row_selected_number, params.columnMappingList);
});

const slice = createSlice({
    name: "BOMReMatch",
    initialState: initialState,
    reducers: {
        SET_bomDataList_based_on_ROW_selected: {
            reducer: (state, action) => {
                state.row_selected_number = parseInt(action.payload.row_selected_number)
                let b = state.bomDataListMainCopy;
                b = b.filter((v, i) => {
                    let row = i + 1;
                    return row >= action.payload.row_selected_number;
                });
                state.bomDataList = b
            },
        },
    },
    extraReducers: {
        [fetch_static_columns.fulfilled]: (state, {payload}) => {
            __remove('BOM_REMATCH_API_CALL');
            if (Object.entries(payload).length > 0) {
                Object.entries(payload).map((v) => {
                    state.static_columns[v[0]] = {
                        bomColumnName: v[0],
                        fileColumnName: v[1],
                    };
                });
            }
            return state;
        },
        [fetch_static_columns.rejected]: (state, {payload}) => {
            __remove('BOM_REMATCH_API_CALL');
        },
        [fetch_saved_columns_data_by_bom_id.fulfilled]: (state, {payload}) => {
            __remove('BOM_REMATCH_SAVED_API_CALL');
            if (payload.bomDataList !== undefined && payload.bomDataList.length > 0) {
                payload.bomDataList.map((v, i) => {
                    payload.bomDataList[i].row_counter_number = i + 1;
                })
                state.bomDataList = payload.bomDataList
                state.bomDataListMainCopy = payload.bomDataList
            }
            if (payload.columnMappingList !== undefined && payload.columnMappingList.length > 0) {
                payload.columnMappingList.map((v) => {
                    v.fileColumnName = v.fileColumnName.trim();
                    v.bomColumnName = v.fileColumnName.trim();
                    state.columnMappingList[v.fileColumnName] = v;
                });
            }
            return state;
        },
        [fetch_saved_columns_data_by_bom_id.rejected]: (state, {payload}) => {
            __remove('BOM_REMATCH_SAVED_API_CALL');
        },
        [fetch_saved_preference_by_bom_id.fulfilled]: (state, {payload}) => {
            __remove('BOM_REMATCH_SAVED_PREFERENCE_API_CALL');
        },
        [fetch_saved_preference_by_bom_id.rejected]: (state, {payload}) => {
            __remove('BOM_REMATCH_SAVED_PREFERENCE_API_CALL');
        },
        [set_saved_columns_preference_by_bom_id.fulfilled]: (state, {payload}) => {
            __remove('BOM_REMATCH_OPERATION_API_CALL');
        },
        [set_saved_columns_preference_by_bom_id.rejected]: (state, {payload}) => {
            __remove('BOM_REMATCH_OPERATION_API_CALL');
        },
    },
});

export let {SET_bomDataList_based_on_ROW_selected} = slice.actions;

export default slice.reducer;
